import { render, staticRenderFns } from "./groupFinal2.vue?vue&type=template&id=68da3de8&scoped=true"
import script from "./groupFinal2.vue?vue&type=script&lang=js"
export * from "./groupFinal2.vue?vue&type=script&lang=js"
import style0 from "./groupFinal2.vue?vue&type=style&index=0&id=68da3de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da3de8",
  null
  
)

export default component.exports